<section id="login">
    <article class="container ingreso login__restore">
        <a mat-dialog-title class="navbar-brand" href="/">
            <picture>
                <source media="(max-width: 767px)" srcset="../../../../assets/img/brand/logo_jelpit_color.svg">
                <img src="../../../../assets/img/brand/logo_jelpit_color.svg" alt="Jelpit">
            </picture>
        </a>
        <div mat-dialog-content>
            <div class="content-wrapper">
                <div class="container text">
                    <h2>Restablece tu contraseña</h2>
                </div>
                <p class="description">Crea una nueva de mínimo ocho caracteres. Puedes incluir mayúsculas, minúsculas,
                    números
                    y signos de puntuación.</p>
                <div class="form">
                    <form [formGroup]="passwordAccount" (ngSubmit)="changePassword()" autocomplete="off">
                        <div class="grid">
                            <div class="grid-12 form_item">
                                <mat-form-field appearance="outline"
                                    [ngClass]="{'field_error': submitted && controlsValidators.password.errors}">
                                    <mat-label>Contraseña nueva</mat-label>
                                    <input type="password" formControlName="password"
                                        placeholder="Escribe tu nueva contraseña" matInput>
                                </mat-form-field>
                                <ng-container *ngIf="submitted && controlsValidators.password.errors">
                                    <p class="error" *ngIf="controlsValidators.password.errors.required">
                                        Ingresa tu nueva contraseña
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.password.errors.minlength">
                                        Recuerda que son mínimo ocho caracteres alfanúmericos
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.password.errors.maxlength">
                                      Recuerda que son máximo quince caracteres alfanúmericos
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.password.errors.numberExistValidator">
                                      Recuerda que debes utilizar mínimo 1 número
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.password.errors.letterValidator">
                                      Recuerda que debes utilizar mínimo 1 letra
                                    <p class="error" *ngIf="controlsValidators.password.errors.specialCharacterValidator">
                                      Recuerda que debes utilizar mínimo 1 signo de puntuación
                                    </p>
                                </ng-container>
                            </div>
                            <div class="grid-12 form_item">
                                <mat-form-field appearance="outline"
                                    [ngClass]="{'field_error': submitted && controlsValidators.repeatPassword.errors}">
                                    <mat-label>Contraseña nueva</mat-label>
                                    <input type="password" formControlName="repeatPassword"
                                        placeholder="Confirma tu contraseña" matInput>
                                </mat-form-field>
                                <ng-container *ngIf="submitted && controlsValidators.repeatPassword.errors">
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.required">
                                        Ingresa tu nueva contraseña
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.minlength">
                                        Recuerda que son mínimo ocho caracteres alfanúmericos
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.maxlength">
                                      Recuerda que son máximo quince caracteres alfanúmericos
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.numberExistValidator">
                                        Recuerda que debes utilizar mínimo 1 número
                                    </p>
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.letterValidator">
                                      Recuerda que debes utilizar mínimo 1 letra
                                    <p class="error" *ngIf="controlsValidators.repeatPassword.errors.specialCharacterValidator">
                                      Recuerda que debes utilizar mínimo 1 signo de puntuación
                                    </p>
                                </ng-container>
                            </div>
                            <div class="grid-12 text-center form-group">
                                <p *ngIf="submitted && errorPassword" class="error">
                                    No coincide la contraseña
                                </p>
                            </div>
                        </div>
                        <div class="form-actions">
                            <button id="restorePass" class="btn_green" type="submit">RESTABLECER CONTRASEÑA</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </article>
</section>
